import { render, staticRenderFns } from "./detailed_explanation.vue?vue&type=template&id=0796a232"
import script from "./detailed_explanation.vue?vue&type=script&lang=js"
export * from "./detailed_explanation.vue?vue&type=script&lang=js"
import style0 from "./detailed_explanation.vue?vue&type=style&index=0&id=0796a232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports